import { render, staticRenderFns } from "./main-page.vue?vue&type=template&id=71bdbec6&scoped=true&"
import script from "./main-page.vue?vue&type=script&lang=js&"
export * from "./main-page.vue?vue&type=script&lang=js&"
import style0 from "./main-page.vue?vue&type=style&index=0&id=71bdbec6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71bdbec6",
  null
  
)

export default component.exports